import React from "react";
import { useHistory } from "react-router-dom";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { APPLICATION_NAME } from "src/_config";

interface SiteLogoProps {
  className?: string;
  style?: React.CSSProperties;
  logoSrc?: string;
  gotoHome?: boolean;
}

const SiteLogo = ({ className, style, logoSrc, gotoHome = true }: SiteLogoProps) => {
  const history = useHistory();
  const gameDetails = useAppGameDetailsSelector();

  const goHome = () => {
    history.push("/");
  };

  return (
    <img
      src={logoSrc || gameDetails?.logo?.original || "/img/logo.png"}
      alt={APPLICATION_NAME + " Logo"}
      className={`linkcls ${className || ""}`}
      style={style}
      onClick={
        gotoHome
          ? goHome
          : () => {
              /* empty handler */
            }
      }
    />
  );
};

export default SiteLogo;
